import { html } from 'lit';
const Journal =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M16.25 4.5H18a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5h4.25V11a.75.75 0 0 0 1.166.624l1.834-1.223 1.834 1.223A.75.75 0 0 0 16.25 11zM4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm7.75 4.599V4.75h3v4.849l-1.084-.723a.75.75 0 0 0-.832 0z" clip-rule="evenodd"/>
  </svg>
`;
export default Journal;
